import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { Customer, Quote, QuoteStatus } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    standalone: false,
    selector: 'app-quote-overview',
    templateUrl: './quote-overview.component.html',
    styleUrl: './quote-overview.component.scss',
})
export class QuoteOverviewComponent {
    quotes: Quote[];
    statuses: QuoteStatus[];
    customers: Customer[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: BrewersUnitOfWork, private router: Router, public auth: AuthService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.statuses = await this.uow.quoteStatuses.whereActive();
        this.customers = await this.uow.customers.getActiveCustomers();
        this.quotes = await this.uow.quotes.whereActive();
    }

    async open(quote?: Quote) {
        this.router.navigate(['/customers/quotes/' + (!!quote?.id ? quote.id : 'new')]);
    }

    async delete(quotes: Quote[]) {
        if (!quotes || quotes.length === 0) return;

        const result = await confirm(`Are you sure you want to delete the selected quote${quotes.length > 1 ? 's' : ''}?`, this.appInfo.appTitle);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const date = new Date();
        quotes.forEach((quote) => {
            quote.deleted = date;
            quote.deletedBy = this.auth.currentUser.userName;
            quote.quoteLines.forEach((line) => {
                line.deleted = date;
                line.deletedBy = this.auth.currentUser.userName;
            });
        });

        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data);
    }
}
